module.exports = __webpack_public_path__ + "static/media/magic-ball.b7dbe66a.png";